import Vue from "vue";
import { Component } from "vue-property-decorator";
import { workOrdersHub } from "@/services/hubs/workOrdersHub";
import { cleaningsHub } from "@/services/hubs/cleaningsHub";
import { appointmentsHub } from "@/services/hubs/appointmentsHub";
import { receptionsHub } from "@/services/hubs/receptionsHub";
import { expeditionsHub } from "@/services/hubs/expeditionsHub";
import { saleOrdersHub } from "@/services/hubs/saleOrdersHub";
import { transportersHub } from "@/services/hubs/transportersHub";
import moment from "moment";
import { IPermission } from "@/models";
import { HubsService } from "@/services";

@Component({
    name: "app",
})
export default class App extends Vue {
    public get isAuthenticated(): boolean {
        return this.$store.getters["user/isAuthenticated"];
    }

    public get lang(): string {
        return this.$store.state.app.lang;
    }

    public set lang(v: string) {
        this.$store.dispatch("app/setLang", v);
    }

    public get isHome(): boolean {
        return this.$route.name === "home" || this.$route.name === "Manage";
    }

    public get isLoading(): boolean {
        return !this.$store.state.app.loaded;
    }

    public toggleFullScreen(): void {
        const doc: any = document;

        if (!doc.fullscreenElement && !doc.webkitFullscreenElement) {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            }
            else if (doc.documentElement.webkitRequestFullScreen) {
                doc.documentElement.webkitRequestFullScreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
            else if (doc.webkitExitFullscreen) {
                doc.webkitExitFullscreen();
            }
        }
    }

    private async startHub(hub: signalR.HubConnection): Promise<void> {
        try {
            await hub.start();
        }
        catch (error) {
            if ((error as any).statusCode !== 401 && (error as any).statusCode !== 404) {
                // Retry in 5 seconds
                setTimeout(() => this.startHub(hub), 60000);
            }
        }

        // Try to reconnect on connection closed
        hub.onclose(async () => { await this.startHub(hub); });
    }
}
